import React from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Editor } from '@tinymce/tinymce-react';

import registry from 'react-mui-lib/registry';


const PAGES = [
    { key: 'site.footer', label: 'Футер (общий для сайта и админки)', url: 'https://www.cryptofox.ru/' },
    { key: 'site.admin_news', label: 'Новости проекта (плашка в админке автора)', url: 'https://www.cryptofox.ru/admin/games' },
    { key: 'site.page.landing', label: 'Главная (www.cryptofox.ru)', url: 'https://www.cryptofox.ru/' },
    { key: 'site.page.privacy', label: 'Политика конфиденциальности (/privacy)', url: 'https://www.cryptofox.ru/privacy' },
    { key: 'site.page.personal', label: 'Согласие на обработку персональных данных (/personal)', url: 'https://www.cryptofox.ru/personal' },
    { key: 'site.page.public_offer', label: 'Публичная оферта (/public-offer)', url: 'https://www.cryptofox.ru/public-offer' },
    { key: 'site.page.gamer_offer', label: 'Оферта для участников (/gamer-offer)', url: 'https://www.cryptofox.ru/gamer-offer' },
    { key: 'site.page.roskomnadzor', label: 'Уведомление Роскомнадзора (/roskomnadzor)', url: 'https://www.cryptofox.ru/roskomnadzor' },
    { key: 'site.seo.title', label: 'SEO: Title (главная)', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.description', label: 'SEO: Description', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.keywords', label: 'SEO: Keywords', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.canonical', label: 'SEO: Canonical URL', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.og_title', label: 'SEO: OG Title', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.og_description', label: 'SEO: OG Description', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.og_image', label: 'SEO: OG Image URL', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.og_type', label: 'SEO: OG Type', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.og_locale', label: 'SEO: OG Locale', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.twitter_card', label: 'SEO: Twitter Card', url: 'https://www.cryptofox.ru/' },
    { key: 'site.seo.theme_color', label: 'SEO: Theme Color', url: 'https://www.cryptofox.ru/' },
    { key: 'site.counter.head', label: 'Счётчики: в <head>', url: 'https://www.cryptofox.ru/' },
    { key: 'site.counter.body_top', label: 'Счётчики: после <body>', url: 'https://www.cryptofox.ru/' },
    { key: 'site.counter.body_bottom', label: 'Счётчики: перед </body>', url: 'https://www.cryptofox.ru/' },
    { key: 'site.stats.cities', label: 'Статистика: городов (стартовое число, к нему прибавляются новые города авторов)', url: 'https://www.cryptofox.ru/' },
    { key: 'site.stats.games', label: 'Статистика: игр (стартовое число, к нему прибавляются новые игры)', url: 'https://www.cryptofox.ru/' },
    { key: 'site.stats.players', label: 'Статистика: игроков (стартовое число; пусто или 0 — не показывать)', url: 'https://www.cryptofox.ru/' }
];


function getPageByKey(key) {
    return PAGES.find(p => p.key === key) || PAGES[0];
}


class SiteContentEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            selectedKey: PAGES[0].key,
            content: '',
            loading: true,
            saving: false,
            message: '',
        };
        this.restClient = registry.get('rest_client');
    }

    componentDidMount() {
        this.loadList();
    }

    loadList() {
        this.setState({ loading: true, message: '' });
        this.restClient.getList('admin-help')
            .then(resp => {
                const rows = (resp.data || []).filter(r => String(r.id).startsWith('site.'));
                const selectedKey = this.state.selectedKey;
                const selectedRow = rows.find(r => r.id === selectedKey) || { content: '' };
                this.setState({
                    rows,
                    selectedKey,
                    content: selectedRow.content || '',
                    loading: false
                });
                return null;
            })
            .catch(err => {
                this.setState({ loading: false, message: 'Ошибка загрузки: ' + err.message });
            });
    }

    handleSelectPage(page) {
        const row = this.state.rows.find(r => r.id === page.key) || { content: '' };
        this.setState({
            selectedKey: page.key,
            content: row.content || '',
            message: ''
        });
    }

    handleChange(value) {
        this.setState({ content: value });
    }

    handleSave() {
        const { selectedKey, content, rows } = this.state;
        const key = (selectedKey || '').trim();

        if (!key) {
            this.setState({ message: 'Выберите страницу из списка' });
            return;
        }

        this.setState({ saving: true, message: '' });

        const existing = rows.some(r => r.id === key);
        const promise = existing
            ? this.restClient.updateEntityForId('admin-help', key, { id: key, content })
            : this.restClient.createEntity('admin-help', { id: key, content });

        promise
            .then(() => {
                this.setState({ saving: false, message: 'Сохранено' });
                this.loadList();
            })
            .catch(err => {
                this.setState({ saving: false, message: 'Ошибка сохранения: ' + err.message });
            });
    }

    renderEditor() {
        const { selectedKey, content } = this.state;
        const isPage = selectedKey.startsWith('site.page.') || selectedKey === 'site.footer' || selectedKey === 'site.admin_news';
        const isCounter = selectedKey.startsWith('site.counter.');

        if (isPage) {
            return (
                <Editor
                    tinymceScriptSrc="//static.app.cryptofox.ru/tinymce/tinymce.min.js"
                    licenseKey="gpl"
                    value={content}
                    onEditorChange={value => this.handleChange(value)}
                    init={{
                        height: 500,
                        menubar: false,
                        plugins: [
                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                            'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
                        ],
                        toolbar:
                            'undo redo | blocks | ' +
                            'bold italic forecolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'link image table | code preview | removeformat | help',
                        content_css: 'https://app.cryptofox.ru/site-static/landing.css',
                        content_style: `
                            .site-header { position: relative !important; }
                            img { max-width: 100%; height: auto; }
                            body { font-family: 'Montserrat', Arial, sans-serif; font-size: 15px; }
                        `,
                        license_key: 'gpl'
                    }}
                />
            );
        }

        const rows = isCounter ? 12 : 6;
        const label = isCounter ? 'Код/значение' : 'Значение';

        return (
            <TextField
                label={label}
                multiline
                rows={rows}
                variant="outlined"
                fullWidth
                value={content}
                onChange={e => this.handleChange(e.target.value)}
                style={{ marginTop: 16, marginBottom: 16, fontFamily: 'monospace' }}
            />
        );
    }

    render() {
        const { rows, selectedKey, loading, saving, message } = this.state;
        const page = getPageByKey(selectedKey);

        if (loading) {
            return <CircularProgress />;
        }

        return (
            <Paper style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
                <Typography variant="h5" gutterBottom>
                    Редактор страниц сайта
                </Typography>

                <div style={{ display: 'flex', gap: 24 }}>
                    <div style={{ width: 300, flexShrink: 0 }}>
                        <List component="nav" dense>
                            {PAGES.map(p => {
                                const row = rows.find(r => r.id === p.key);
                                return (
                                    <ListItem
                                        key={p.key}
                                        button
                                        selected={p.key === selectedKey}
                                        onClick={() => this.handleSelectPage(p)}
                                    >
                                        <ListItemText
                                            primary={p.label}
                                            secondary={row ? 'есть сохранённая версия' : 'не сохранена'}
                                        />
                                    </ListItem>
                                );
                            })}
                        </List>
                    </div>

                    <div style={{ flex: 1 }}>
                        <Typography variant="h6" gutterBottom>
                            {page.label}
                        </Typography>

                        {(selectedKey.startsWith('site.page.') || selectedKey === 'site.footer' || selectedKey === 'site.admin_news') && (
                            <div style={{ marginBottom: 8 }}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    href={page.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Открыть страницу в новом окне
                                </Button>
                            </div>
                        )}

                        <Typography variant="caption" component="div" style={{ marginBottom: 8, color: '#757575' }}>
                            URL: <a href={page.url} target="_blank" rel="noopener noreferrer">{page.url}</a>
                        </Typography>

                        {this.renderEditor()}

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.handleSave()}
                            disabled={saving}
                            style={{ marginRight: 12 }}
                        >
                            {saving ? <CircularProgress size={20} /> : 'Сохранить'}
                        </Button>

                        <Button
                            variant="outlined"
                            onClick={() => this.loadList()}
                            disabled={saving}
                        >
                            Обновить
                        </Button>

                        {message && (
                            <Typography
                                style={{ marginTop: 12, color: message.startsWith('Ошибка') ? '#d32f2f' : '#388e3c' }}
                            >
                                {message}
                            </Typography>
                        )}
                    </div>
                </div>
            </Paper>
        );
    }
}

export default SiteContentEditor;
